<script>

	import { onMount, onDestroy, tick } from 'svelte';

	import Avatar from "./Avatar.svelte";

	import {
		attendees,
		event,
		participants,
		room,
		trackPublications,
		layout,
		banner,
		highlight
	} from '../lib/stores.js';

	import { horizontalSlide } from "../lib/horizontalSlide.js";
	import { pollAudioLevel } from '../lib/pollAudioLevel.js';
	// import { postServerData } from '../lib/prelude.js';

	export let participant;
	export let i;

	let attendeeId = participant.id;

	let over = false;
	let mounted = false;

	let screenShare = false;

	let videoElement;
	let videoAttached = false;

	let audioElement;
	let audioAttached = false;

	let invisible = true;
	let muted = false;
	let audioLevel = 0;

	let elem;
	let boxWidth = 0;
	let aspectRatio = '16/9';
	let tall = false;

	let showName = false;

	// let counter = 0;
	// let mountCount = 0;

	onMount(async () => {

		// const j = JSON.stringify(participant);
		// postServerData('virtual/studio/debug', {
		// 	sessionRef: $session.ref,
		// 	message: "Participant added to stage",
		// 	json: j
		// });

		if (participant.id.startsWith('s_')) {
			screenShare = true;
			attendeeId = participant.id.substring(2);
		} else {
			attendeeId = participant.id;
		}

		initShowName();

		mounted = true;

		// setTimeout(() => {
		// 	mountCount++;
		// }, 1000);

		// setTimeout(() => {
		// 	rtcTracks();
		// }, 2000);

		setTimeout(() => {
			rtcTracks();
		}, 200);

	});

	const setAspectRatio = (iterated) => {
		if (screenShare) {
			if (elem) {
				const w = videoElement.videoWidth;
				const h = videoElement.videoHeight;
				// 24 Aug 2026 -- videoWidth/videoHeight are both 0 until the
				// browser has actually decoded a first frame, which for a
				// just-started screen share can take a moment longer than
				// camera. Without this guard, that initial 0/0 read
				// overwrites the sensible '16/9' default (or a previously
				// good value) with an invalid CSS aspect-ratio, collapsing
				// the box until the resize event or the retry below corrects
				// it -- this is what was showing up as a delay before the
				// screenshare became visible.
				if (w && h) {
					aspectRatio = `${w}/${h}`;
					const percent = w / h;
					const slot = elem.parentNode;
					const slotWidth = slot.offsetWidth;
					const slotHeight = slot.offsetHeight;
					const slotPercent = slotWidth / slotHeight;
					tall = (slotPercent > percent) ? true : false;
				}
				// console.log('aspectRatio', aspectRatio, percent, slotPercent, tall);
			}
			if (!iterated) {
				setTimeout(() => {
					setAspectRatio(true);
				}, 400);
			}
		}
	}

	async function rtcTracks() {

		// counter++;

		await tick();

		if ($trackPublications[participant.id] && $trackPublications[participant.id].video) {
			invisible = $trackPublications[participant.id].video.isMuted ? true : false;
			if (!videoAttached && $trackPublications[participant.id].video.track) {

				// console.log('(stage) attaching video track', participant.id);

				$trackPublications[participant.id].video.track.attach(videoElement);
				videoElement.addEventListener("resize", setAspectRatio);
				videoAttached = true;

				// const j = JSON.stringify(participant);
				// postServerData('virtual/studio/debug', {
				// 	sessionRef: $session.ref,
				// 	message: "Participant video attached",
				// 	json: j
				// });

			}
		}

		if ($trackPublications[participant.id] && $trackPublications[participant.id].audio) {
			if (!audioAttached && $trackPublications[participant.id].audio.track) {
				// console.log('(stage) attaching audio track', participant.id);
				$trackPublications[participant.id].audio.track.attach(audioElement);
				audioAttached = true;
			}
		}

		checkMuted();
		setAspectRatio();

	}

	function checkMuted() {
		let m = false;
		if ($trackPublications && $trackPublications[participant.id] && $trackPublications[participant.id].audio) {
			if ($trackPublications[participant.id].audio.isMuted) {
				m = true;
			} else {
				m = false;
			}
		}
		if (participant.m) m = true;
		muted = m;
	}

	function initShowName() {
		if (screenShare) {
			showName = false;
		} else {
			if ($event.setup.virtual.studio && $event.setup.virtual.studio.nameTags && $event.setup.virtual.studio.nameTags.display) {
				if ($event.setup.virtual.studio.nameTags.display == 'show') {
					showName = true;
				} else if ($event.setup.virtual.studio.nameTags.display == 'hide') {
					showName = false;
				} else if ($event.setup.virtual.studio.nameTags.display == 'timed') {
					showName = true;
					setTimeout(() => {
						showName = false;
					}, 30000);
				}
			}
		}
	}

	$: if (mounted && $room && $trackPublications) {
		rtcTracks();
	}

	$: checkMuted(participant);

	$: if ($layout || $participants) {
		setAspectRatio();
	}

	// let publicationsCount = 0;

	// function setPublicationsCount() {
	// 	let c = 0;
	// 	Object.keys($trackPublications).forEach(function (i) {
	// 		Object.keys($trackPublications[i]).forEach(function (k) {
	// 			c++;
	// 		});
	// 	});
	// 	publicationsCount = c;
	// }

	// $: setPublicationsCount($trackPublications);

</script>

<style>

	/*.video.screenShare {
		transition: aspect-ratio 0.3s ease;
	}*/

	:global(.layout.side) .video.screenShare,
	:global(.layout.cinema) .video.screenShare,
	:global(.layout.p1) .video.screenShare {
		aspect-ratio: var(--ratio);
	}

	:global(.layout.p1) .video.screenShare {
		width: 100%;
		height: auto;
	}

	:global(.layout.side) .video.screenShare.tall,
	:global(.layout.cinema) .video.screenShare.tall,
	:global(.layout.p1) .video.screenShare.tall {
		width: unset;
		min-width: unset;
		height: 100%;
	}

	.video video {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
/*		z-index: 20;*/
		object-fit: cover;
	}

	.video:after {
		content: '';
		position: absolute;
		inset: 0;
		z-index: 2;
	}

	.video video.blur {
		top: -2%;
		left: -2%;
		width: 104%;
		height: 104%;
	}

	.video video.mirror {
		transform: scale(-1,1);
	}

	.video .nameTag {
		position: absolute;
		left: calc(var(--sw) * 0.01);
		bottom: calc(var(--sw) * 0.01);
		box-sizing: border-box;
		max-width: calc(100% - ((var(--sw) * 0.01) * 2));
		line-height: 1;
		z-index: 10;
	}

	:global(.layout.cinema:not(.p1).hasBanner .slot:nth-of-type(1)) .video .nameTag {
		transition: bottom 0.2s ease;
		bottom: calc(100% - ((var(--sh) - var(--bh) - ((var(--sw) * 0.016) * 4.4)) - (((var(--sw) / 4) - (var(--sw) * 0.032)) * 0.5625)) + (var(--sw) * 0.005));
	}

	:global(.layout.cinema.p6.hasBanner .slot:nth-of-type(1)) .video .nameTag {
		bottom: calc(100% - ((var(--sh) - var(--bh) - ((var(--sw) * 0.016) * 4.4)) - (((var(--sw) / 5) - (var(--sw) * 0.032)) * 0.5625)) + (var(--sw) * 0.005));
	}

	.video .nameTag:before {
		content: '';
		position: absolute;
		inset: 0;
		border-radius: calc(var(--sw) * 0.002);
		background-color: var(--nameTagBgColor);
		opacity: var(--nameTagBgOpacity);
		z-index: 0;
		box-shadow: 0 0 calc(var(--sw) * 0.002) rgba(0, 0, 0, 0.3);
		transition: background-color 0.4s ease, opacity 0.4s ease;
	}

	.video .nameTag > span {
		position: relative;
		z-index: 1;
		display: block;
		line-height: 1;
		font-size: calc(var(--sw) * 0.016);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		color: var(--nameTagTextColor);
		font-family: var(--nameTagFont);
		transition: color 0.4s ease;
		padding: calc(var(--sw) * 0.008) calc(var(--sw) * 0.01);
	}

	:global(.layout.inset .slot:nth-of-type(1)) .video .nameTag {
		top: calc(var(--sw) * 0.01);
		bottom: auto;
	}

	.video {
		background: rgba(0,0,0,0.1);
	}
	.video.invisible {
		background: var(--blend-120);
	}
	.video.invisible video {
		opacity: 0;
	}
	.video :global(.avatar) {
		z-index: 10;
		top: 50%;
		left: 50%;
		width: 20%;
		height: auto;
		aspect-ratio: 1 / 1;
		transform: translate(-50%,-50%);
	}
	.video :global(.avatar abbr) {
		font-size: calc(var(--boxWidth) * 0.1);
	}
	.video.invisible:before {
		content: '';
		z-index: 9;
		position: absolute;
		top: 50%;
		left: 50%;
		width: 20%;
		height: auto;
		aspect-ratio: 1 / 1;
		transform: translate(-50%,-50%) scale(calc((var(--audioLevel) / 20) + 1));
		transition: transform 0.2s ease;
		background: var(--panelColor);
		opacity: 0.4;
		border-radius: 100%;
	}

	/*.markers {
		position: absolute;
		z-index: 10000;
		top: 20px;
		left: 20px;
		display: flex;
		gap: 20px;
	}

	.markers > div {
		padding: 5px;
		font-size: 30px;
		display: flex;
		background: white;
		color: black;
		font-weight: bold;
		border: 1px solid black;
		box-sizing: border-box;
	}*/

</style>

{#if mounted}
	<div
		class="video"
		class:over={over}
		class:invisible
		class:tall
		class:screenShare={screenShare && (i == 0)}
		on:mouseenter={() => { over = true }}
		on:mouseleave={() => { over = false }}
		bind:clientWidth={boxWidth}
		bind:this={elem}
		style="--boxWidth:{boxWidth}px;--audioLevel:{audioLevel};--ratio:{aspectRatio};"
	>

		<!-- svelte-ignore a11y-media-has-caption -->
		<video id="video-{participant.id}" bind:this={videoElement} class:mirror={participant.f && !screenShare} class:blur={participant.b && !screenShare} />

		{#if invisible}
			<Avatar {attendeeId} {invisible} {screenShare} bind:audioLevel />
		{/if}

		<audio id="audio-{participant.id}" bind:this={audioElement} />

		{#if showName && $attendees[attendeeId] && !(participant.s && ($banner || $highlight))}
			<span class="nameTag" in:horizontalSlide={{ duration: 400, delay: 400 }} out:horizontalSlide|local={{ duration: 400 }}>
				<span>{$attendees[attendeeId].f} {$attendees[attendeeId].l}</span>
			</span>
		{/if}

		<!-- <div class="markers">
			<div>{mountCount}</div>
			<div>{publicationsCount}</div>
			{#if ($trackPublications[participant.id] && $trackPublications[participant.id].audio)}
				<div>Y</div>
			{/if}
			{#if ($trackPublications[participant.id] && $trackPublications[participant.id].audio && $trackPublications[participant.id].audio.isSubscribed)}
				<div>S</div>
			{/if}
			<div>{counter}</div>
			{#if audioAttached}
				<div>a</div>
			{/if}
		</div> -->

	</div>
{/if}